import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { StateCategory } from '../../types';

export interface CampaignFiltersState {
  clearFilters: () => void;
  campaignTypes: string[];
  setCampaignTypes: (values: string[]) => void;
  channelTypes: string[];
  setChannelTypes: (values: string[]) => void;
  creators: string[];
  setCreators: (values: string[]) => void;
  labels: number[];
  setLabels: (values: number[]) => void;
  lists: number[];
  setLists: (values: number[]) => void;
  media: string[];
  setMedia: (value: string[]) => void;
  modifiers: string[];
  setModifiers: (values: string[]) => void;
  parentCampaignId?: number;
  setParentCampaignId: (value: number) => void;
  placements: number[];
  setPlacements: (values: number[]) => void;
  stateCategory: StateCategory;
  setStateCategory: (value: StateCategory) => void;
  states: string[];
  setStates: (values: string[]) => void;
  searchQuery: string;
  setSearchQuery: (value: string) => void;
  alerts: string[];
  setAlerts: (values: string[]) => void;
  templateType: string[];
  setTemplateType: (values: string[]) => void;
  templateStatus: string[];
  setTemplateStatus: (values: string[]) => void;
  templateQualityRating: string[];
  setTemplateQualityRating: (values: string[]) => void;
  isFavorites: boolean;
  setIsFavorites: (values: boolean) => void;
  hideFolders: boolean;
  setHideFolders: (value: boolean) => void;
}

export const CampaignFiltersContext = createContext<CampaignFiltersState>({
  clearFilters: noop,
  campaignTypes: [],
  setCampaignTypes: noop,
  channelTypes: [],
  setChannelTypes: noop,
  creators: [],
  setCreators: noop,
  labels: [],
  setLabels: noop,
  lists: [],
  setLists: noop,
  media: [],
  setMedia: noop,
  modifiers: [],
  setModifiers: noop,
  parentCampaignId: undefined,
  setParentCampaignId: noop,
  placements: [],
  setPlacements: noop,
  stateCategory: '',
  setStateCategory: noop,
  states: [],
  setStates: noop,
  searchQuery: '',
  setSearchQuery: noop,
  alerts: [],
  setAlerts: noop,
  templateType: [],
  setTemplateType: noop,
  templateStatus: [],
  setTemplateStatus: noop,
  templateQualityRating: [],
  setTemplateQualityRating: noop,
  isFavorites: false,
  setIsFavorites: noop,
  hideFolders: false,
  setHideFolders: noop,
});

export const useCampaignFiltersContext = () => useContext(CampaignFiltersContext);
